(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var parse = function (t, d) { try { return JSON.parse(t); } catch (e) { return d; } };
  var each = function (sel, fn) { $$(sel).forEach(function (r) { try { fn(r); } catch (e) { if (window.console) console.error('[muuu]', sel, e); } }); };

  /* mobile menu */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mu-burger]');
    if (!b) return;
    var d = document.getElementById(b.getAttribute('aria-controls'));
    var open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open); d.setAttribute('data-open', open);
    b.textContent = open ? '✕' : '☰';
  });

  /* cart count */
  function setCount(n) { $$('[data-mu-count]').forEach(function (el) { el.textContent = n; }); }
  function refreshCount() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }

  /* toast */
  function toast(msg) {
    var t = $('#mu-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'mu-toast'; t.className = 'mu mu-toast'; t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + msg + '</span><a class="mu-btn mu-btn--cream" href="/cart">View cart</a><a class="mu-btn mu-btn--pink" href="/checkout">Checkout</a>';
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 6000);
  }

  function addToCart(items, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { refreshCount(); toast('Mooved to your cart!'); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function (err) { alertMsg(btn, (err && (err.description || err.message)) || 'Sorry, that didn’t work. Please try again.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  function alertMsg(btn, msg) { var p = btn && btn.parentNode.querySelector('[data-mu-err]'); if (p) { p.textContent = msg; p.hidden = false; } else { toast(msg); } }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mu-add]');
    if (!b) return;
    e.preventDefault();
    var it = { id: Number(b.getAttribute('data-mu-add')), quantity: Number(b.getAttribute('data-qty') || 1) };
    var pl = b.getAttribute('data-plan'); if (pl) it.selling_plan = Number(pl);
    addToCart([it], b);
  });

  /* shop cards: one-time vs subscribe */
  document.addEventListener('change', function (e) {
    var root = e.target.closest('[data-mu-pick]'); if (!root || !e.target.matches('input[type=radio]')) return;
    var i = e.target, b = $('[data-mu-add]', root); if (!b) return;
    b.setAttribute('data-mu-add', i.getAttribute('data-variant'));
    if (i.getAttribute('data-plan')) b.setAttribute('data-plan', i.getAttribute('data-plan')); else b.removeAttribute('data-plan');
    var pr = $('[data-mu-price]', b); if (pr) pr.textContent = money(Number(i.getAttribute('data-total')));
  });

  /* promo code: copy + apply */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mu-code]');
    if (!b) return;
    var code = b.getAttribute('data-mu-code');
    try { navigator.clipboard && navigator.clipboard.writeText(code); } catch (x) {}
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js').catch(function () {});
    var o = b.textContent; b.textContent = 'Applied ✓';
    setTimeout(function () { b.textContent = o; }, 2500);
  });

  /* moo facts */
  each('[data-mu-moo]', function (root) {
    var facts = parse(root.getAttribute('data-facts') || '[]', []), i = 0;
    if (!facts.length) { var ff = $('.mu-moo__fact', root); facts = ff ? [ff.textContent] : []; }
    if (!facts.length) return;
    var btn = $('.mu-moo__btn', root), n = $('.mu-moo__n', root), f = $('.mu-moo__fact', root);
    btn.addEventListener('click', function () {
      i = (i + 1) % facts.length;
      f.textContent = facts[i]; n.textContent = 'Moo fact ' + (i + 1) + ' of ' + facts.length;
      btn.classList.add('is-mooing'); setTimeout(function () { btn.classList.remove('is-mooing'); }, 150);
      btn.textContent = ['Moo!', 'Mooo!', 'MOOO!', 'Moo?', 'Moo!!', 'Muuu!'][i % 6];
    });
  });

  /* format chooser + scoop maths */
  each('[data-mu-fmt-root]', function (root) {
    var data = parse(root.getAttribute('data-formats'), null) || { powder: { total: 40, mg: 2000, price: 3999, short: 'tub' }, caps: { total: 45, mg: 1000, price: 3999, short: 'bottle' } };
    var state = { fmt: 'powder', serves: 1 };
    function render() {
      var f = data[state.fmt] || data.powder;
      root.setAttribute('data-fmt', state.fmt);
      $$('[data-pick-fmt]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pick-fmt') === state.fmt); });
      $$('[data-pick-serves]', root).forEach(function (b) { b.setAttribute('aria-pressed', Number(b.getAttribute('data-pick-serves')) === state.serves); });
      var set = function (k, v) { $$('[data-v="' + k + '"]', root).forEach(function (el) { el.textContent = v; }); };
      set('days', Math.floor(f.total / state.serves));
      set('perday', money(Math.round(f.price / f.total * state.serves)));
      set('mg', (f.mg * state.serves).toLocaleString('en-AU'));
      set('short', f.short);
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pick-fmt]'); if (a) { state.fmt = a.getAttribute('data-pick-fmt'); render(); }
      var s = e.target.closest('[data-pick-serves]'); if (s) { state.serves = Number(s.getAttribute('data-pick-serves')); render(); }
    });
    render();
  });

  /* cow spots */
  each('[data-mu-spots]', function (root) {
    var count = $('[data-spotted]', root);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.mu-spot'); if (!b) return;
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true');
      var n = $$('.mu-spot[aria-pressed=true]', root).length;
      count.textContent = n;
      if (n === $$('.mu-spot', root).length) { var m = $('[data-all-spotted]', root); if (m) m.hidden = false; }
    });
  });

  /* recipe tabs */
  each('[data-mu-tabs]', function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      var k = b.getAttribute('data-tab');
      $$('[data-tab]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      $$('[data-panel]', root).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === k); });
    });
  });

  /* product gallery */
  each('[data-mu-gallery]', function (root) {
    var main = $('.mu-gal__main img', root), thumbs = $$('.mu-gal__thumbs button', root), i = 0;
    function go(n) {
      i = (n + thumbs.length) % thumbs.length; var t = thumbs[i];
      main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt');
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var p = $('.mu-gal__nav--p', root), nx = $('.mu-gal__nav--n', root);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
  });

  /* product buy box */
  each('[data-mu-buy]', function (root) {
    var free = Number(root.getAttribute('data-free')) || 5900;
    var btn = $('.mu-atc', root), msg = $('[data-ship-msg]', root), bar = $('[data-ship-bar]', root);
    function sel() { return $('input[name=mu-opt]:checked', root); }
    function render() {
      var s = sel(); if (!s) return;
      var total = Number(s.getAttribute('data-total'));
      var ap = $('[data-atc-price]', root); if (ap) ap.textContent = money(total);
      var left = free - total;
      msg.textContent = left > 0 ? 'Spend ' + money(left) + ' more for free shipping' : 'Free shipping unlocked 🎉';
      bar.style.width = Math.min(100, Math.round(total / free * 100)) + '%';
    }
    root.addEventListener('change', render);
    btn.addEventListener('click', function (e) {
      e.preventDefault(); var s = sel(); if (!s) return;
      var it = { id: Number(s.getAttribute('data-variant')), quantity: Number(s.getAttribute('data-qty')) }; if (s.getAttribute('data-plan')) it.selling_plan = Number(s.getAttribute('data-plan')); addToCart([it], btn);
    });
    render();
  });

  /* carousels: [data-mu-car] > .mu-car__track > items */
  if (!document.getElementById('mu-car-css') && document.querySelector('[data-mu-car]')) {
    var cs = document.createElement('style'); cs.id = 'mu-car-css';
    cs.textContent = '.mu-car__track{display:flex;gap:20px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;padding:2px;outline:none}' +
      '.mu-car__track::-webkit-scrollbar{display:none}' +
      '.mu-car__track>*{flex:0 0 calc((100% - (var(--per,3) - 1) * 20px) / var(--per,3));scroll-snap-align:start;min-width:0;margin:0}' +
      '.mu-car__bar{display:flex;align-items:center;justify-content:center;gap:16px;margin-top:22px}.mu-car__bar[hidden]{display:none}' +
      '.mu-car__btn{width:48px;height:48px;border-radius:50%;border:2px solid var(--mu-blue);background:#fff;color:var(--mu-blue);font-size:24px;line-height:1;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:background .15s,color .15s}' +
      '.mu-car__btn:hover{background:var(--mu-blue);color:var(--mu-cream)}' +
      '.mu-car__dots{display:flex;gap:8px;flex-wrap:wrap;justify-content:center}' +
      '.mu-car__dots button{width:10px;height:10px;border-radius:50%;border:0;padding:0;background:var(--mu-line);cursor:pointer;transition:width .2s,background .2s}' +
      '.mu-car__dots button[aria-current=true]{width:28px;border-radius:6px;background:var(--mu-blue)}' +
      '@media (max-width:989px){.mu-car__track>*{flex-basis:calc((100% - 20px) / 2)}}' +
      '@media (max-width:600px){.mu-car__track{gap:12px}.mu-car__track>*{flex-basis:86%}}';
    document.head.appendChild(cs);
  }
  each('[data-mu-car]', function (root) {
    var track = $('.mu-car__track', root); if (!track) return;
    var slides = [].slice.call(track.children); if (slides.length < 2) return;
    var bar = document.createElement('div'); bar.className = 'mu-car__bar';
    bar.innerHTML = '<button type="button" class="mu-car__btn" data-prev aria-label="Previous">‹</button><div class="mu-car__dots"></div><button type="button" class="mu-car__btn" data-next aria-label="Next">›</button>';
    track.parentNode.insertBefore(bar, track.nextSibling);
    var dotsEl = $('.mu-car__dots', bar);
    function step() { return (slides[1].offsetLeft - slides[0].offsetLeft) || track.clientWidth; }
    function pages() { return Math.max(1, slides.length - Math.max(1, Math.round(track.clientWidth / step())) + 1); }
    function idx() { return Math.round(track.scrollLeft / step()); }
    function go(i) { var n = pages(); i = ((i % n) + n) % n; track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    function dots() {
      var n = pages(), cur = Math.min(idx(), n - 1);
      bar.hidden = n < 2;
      if (dotsEl.children.length !== n) {
        dotsEl.innerHTML = '';
        for (var k = 0; k < n; k++) { (function (k) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to slide ' + (k + 1)); d.addEventListener('click', function () { go(k); restart(); }); dotsEl.appendChild(d); })(k); }
      }
      [].forEach.call(dotsEl.children, function (d, k) { d.setAttribute('aria-current', k === cur); });
    }
    $('[data-prev]', bar).addEventListener('click', function () { go(idx() - 1); restart(); });
    $('[data-next]', bar).addEventListener('click', function () { go(idx() + 1); restart(); });
    var timer = null, paused = false, auto = Number(root.getAttribute('data-autoplay')) || 5000;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) auto = 0;
    function restart() { clearInterval(timer); if (auto) timer = setInterval(function () { if (!paused && document.visibilityState === 'visible' && pages() > 1) go(idx() + 1); }, auto); }
    root.addEventListener('mouseenter', function () { paused = true; }); root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; }); root.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(dots, 80); }, { passive: true });
    window.addEventListener('resize', dots);
    dots(); restart();
  });

  refreshCount();
})();
